class QBLoginCtrl {
  constructor(AuthService, $state, FlashService, FEService, $scope, $window) {
    'ngInject';
    this.$state = $state;
    this.$window = $window;
    this.AuthService = AuthService;
    this.FlashService = FlashService;
    this.FEService = FEService;
    this.userMessages = [];
    this.showRealmMessage = false;
    // TODO: We probably want to centrally control "provider"s...
    // but YAGNI for now..
    this.authMethod = 'STANDARD';
    this.authData = {
      "provider": "Quick Base"
    };
    this.loadNote = "Logging In...";
    const stopWatch = $scope.$watch("$ctrl.options", (newVal, oldVal) => {
      if(newVal && newVal["realm"]){
        this.authData["realm"] = newVal["realm"];
        stopWatch();
      }
    });
  }
  
  cleanRealm(){
    if (this.authData.realm) {
      this.showRealmMessage = this.showRealmMessage || this.authData.realm.includes('.');
      this.authData.realm = this.authData.realm.toLowerCase().trim().split('.')[0];
    }
  }

  setAuthMethod(method){
    const {realm} = this.authData;
    this.authData = {
      "provider": "Quick Base",
      realm
    };
    this.authMethod = method;
  }
  focusOnRealm(){
    $('#realm').focus();
  }

  async login(authData) {
    // authData.username is the account email (type="email" here, enforced on the
    // server too). It equals the Firebase uid, so a lockout revokes the right sessions.
    this.userMessages = [];
    this.loading = true;
    try {
      const success = await this.AuthService.login(authData);
      this.FlashService.success("Thanks for Logging In.");
      if( this.options && this.options.successState ){
        this.$state.go(this.options.successState, this.options.successStateParams);
      }
      if( this.options && this.options.onSuccess ){
        this.options.onSuccess(success);
      }
    } catch (error){
      this.FlashService.error(error.message);
      this.userMessages.push({"class":"alert-danger", "message": error.message});
      this.options.validationErrorMessage = '';
      if( (this.options || {}).onFailure ){
        this.options.onFailure(error);
      }
    }
    this.loading = false;
  }
  
  cleanTitle() { // don't start login URL with '.' if realm (for example) is missing
    return this.options.title.replace(/ \.(\w+.*$)/, ' $1');
  }

  changeProvider() {
    //this.$state.go('login', { provider: '?' }, { reload: true });
  }

  async logout() {
    await this.AuthService.logout(true);
    this.$window.location.reload();
  }
}

export default {
  bindings: {
    options: "<"
  },
  templateUrl: "providers/quick-base/qb-auth/qb-login/qb-login.component.html",
  controller: QBLoginCtrl
};
